import { Button } from '@/components/ui/button';
import { IconPlus } from '@tabler/icons-react';
import { selectSetOpen, useConnectionStore } from '../store';

export function TasksPrimaryButtons() {
  const setOpen = useConnectionStore(selectSetOpen);
  return (
    <div className='flex gap-2'>
      <Button className='space-x-1' onClick={() => setOpen('create')}>
        <span>Adicionar Whatsapp</span> <IconPlus size={18} />
      </Button>
    </div>
  )
}
